module.exports = __webpack_public_path__ + "bd34d72c44185815118e2e57723fa9b1.pdf";